import Highcharts from 'highcharts';

export const figure44 = {
  chart: {
      zoomType: 'xy',
      animation: false,
      marginTop: 50,
      marginLeft: 180,
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: 'bar',
      height: '600px',
      backgroundColor: 'rgba(255, 255, 255, 0.0)',
      style: {
        fontFamily: 'Montserrat'
      }
    },

    colors: ['#00b0f0', '#b4c7e7'],

    credits: {
      enabled: false
    },
    title: {
      text: null
    },
    subtitle: {
      text: null
    },

    plotOptions: {
      series: {
        borderWidth: 0,
        marker: {
          symbol: 'circle',
          enabled: false,
          states: {
            hover: {
              enabled: true,
              radius: 5
            }
          }
        }
      }
    },

    exporting: {
      enabled: false
    },

    xAxis: [{
		 useHTML: true,			      
		 categories: [
			      "أقل من 11 دولارًا أمريكيًا/م³",
			      "11 إلى 20 دولارًا أمريكيًا/م³",
			      "21 إلى 30 دولارًا أمريكيًا/م³",
			      "31 إلى 40 دولارًا أمريكيًا/م³",
			      "41 إلى 50 دولارًا أمريكيًا/م³",
			      "51 إلى 60 دولارًا أمريكيًا/م³",
			      "61 إلى 70 دولارًا أمريكيًا/م³",
			      "71 إلى 80 دولارًا أمريكيًا/م³",
			      "81 إلى 90 دولارًا أمريكيًا/م³",
			      "91 إلى 100 دولار أمريكي/م³",
			      "أكثر من 100 دولار أمريكي/م³",
      ],
      lineColor: "#d7d7d7",
      tickColor: "#d7d7d7",
      useHTML: true,
      tickLength: 16,
      labels: {
	     style: {
	    useHTML: true,
          fontWeight: 'normal',
          color: '#999999',
          fontSize: '12px'
        }
      },
    }],
    yAxis: [{
      labels: {
        format: '{value}',
        style: {
          fontWeight: 'normal',
          color: '#999999',
          fontSize: '12px'
        },
      },
      max: 50,
      min: 0,
      tickInterval: 10,
      gridLineWidth: 0,
      title: {
        text: null,
        style: {
          color: Highcharts.getOptions().colors[1]
        }
      }
    }],
    tooltip: {
      shared: true,
      useHTML: true,
      hideDelay: 500,
      backgroundColor: null,
      borderWidth: 0,
      shadow: false,
      style: {
        padding: 0
      }
    },
    legend: {
      enabled: false,
    },

    series: [
    {
	    name: '2015',
	    tooltip: {
			  valueSuffix: '%'
		  },
		  dataLabels: {
			  enabled: false,
			  style: {
					   fontWeight: 'normal',
					   textOutline: false,
					   color: '#999999',
					   fontSize: '12px'
				   }
		  },
		  data: [
			 42,
			 16,
			 6,
			 7,
			 6,
			 4,
			 2,
			 2,
			 2,
			 2,
			 11,
			],
    },
    {
    name: '2020',
      tooltip: {
        valueSuffix: '%'
      },
      dataLabels: {
        enabled: false,
        style: {
          fontWeight: 'normal',
          textOutline: false,
          color: '#999999',
          fontSize: '12px'
        }
      },
      data: [
        41,
        16,
        7,
        7,
        4,
        5,
        1,
        3,
	3,
	3,
        9,
      ]
    }]
}
